// Stock Counter JavaScript
document.addEventListener('DOMContentLoaded', function () {
  const stockCounter = document.getElementById('stock-counter');
  const stockProgressBar = document.getElementById('stock-progress-bar');

  if (stockCounter && stockProgressBar) {
    // Get stock from localStorage or start with 100
    let currentStock = parseInt(localStorage.getItem('stockCounter') || '100');
    const maxStock = 100;
    const minStock = 0;

    // Initialize display with saved stock value
    stockCounter.textContent = currentStock;
    const progressPercentage = (currentStock / maxStock) * 5;
    stockProgressBar.style.width = progressPercentage + '%';

    // Set initial styling
    stockCounter.style.color = '#000000';
    stockCounter.style.fontWeight = 'normal';
    stockProgressBar.style.background = '#dc3545';

    function updateStock() {
      if (currentStock > 10) {
        currentStock--;
        stockCounter.textContent = currentStock;

        // Save to localStorage
        localStorage.setItem('stockCounter', currentStock.toString());

        // Update progress bar width
        const progressPercentage = (currentStock / maxStock) * 5;
        stockProgressBar.style.width = progressPercentage + '%';

        // Update text color and progress bar color based on stock level
        stockCounter.style.color = '#000000';
        stockCounter.style.fontWeight = 'normal';
        stockProgressBar.style.background = '#dc3545';

        // Schedule next update with random interval
        setTimeout(updateStock, Math.random() * 3000 + 2000);
      } else if (currentStock === 10) {
        // Stop at 10 pieces and stay there
        stockCounter.textContent = currentStock;
        stockCounter.style.color = '#000000';
        stockCounter.style.fontWeight = 'normal';

        // Save to localStorage
        localStorage.setItem('stockCounter', currentStock.toString());

        // Update progress bar width for 10 pieces
        const progressPercentage = (currentStock / maxStock) * 5;
        stockProgressBar.style.width = progressPercentage + '%';
        stockProgressBar.style.background = '#dc3545';

        // Schedule a reset to 100 after a longer delay (30-60 seconds)
        setTimeout(() => {
          currentStock = 100;
          stockCounter.textContent = currentStock;
          stockCounter.style.color = '#000000';
          stockCounter.style.fontWeight = 'normal';
          stockProgressBar.style.width = '5%';
          stockProgressBar.style.background = '#dc3545';

          // Save reset to localStorage
          localStorage.setItem('stockCounter', currentStock.toString());

          // Start the countdown again
          setTimeout(updateStock, Math.random() * 3000 + 2000);
        }, Math.random() * 30000 + 30000); // 30-60 seconds delay
      }
    }

    // Start the counter
    setTimeout(updateStock, 2000);
  }
});
